import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PrintButton({
  label = "Print",
  testId,
  variant = "outline",
  size = "default",
  onClick,
}) {
  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      onClick={onClick || (() => window.print())}
      className="print-hidden"
      data-testid={testId}
    >
      <Printer className="mr-2 h-4 w-4" />
      {label}
    </Button>
  );
}